import { render, staticRenderFns } from "./strip.vue?vue&type=template&id=33a985a6&scoped=true&lang=pug&"
import script from "./strip.vue?vue&type=script&lang=js&"
export * from "./strip.vue?vue&type=script&lang=js&"
import style0 from "./strip.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./strip.vue?vue&type=style&index=1&id=33a985a6&scoped=true&lang=scss&"
import style2 from "./strip.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./strip.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a985a6",
  null
  
)

export default component.exports